import { useState, useEffect } from "react";
import api from "@/lib/api";
import { GitBranch } from "lucide-react";
import { Link } from "react-router-dom";

export default function LifecycleChain({ contractId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!contractId) return;
    api.get(`/contracts/${contractId}/lineage-chain`)
      .then(r => setData(r.data))
      .catch(() => setError(true));
  }, [contractId]);

  if (error || !data) return null;
  if ((data.chain || []).length <= 1) return null; // no siblings

  return (
    <div className="bg-white border border-slate-200 rounded-md mb-4" data-testid="lifecycle-chain">
      <div className="px-4 py-2.5 border-b border-slate-200 bg-slate-50 rounded-t-md flex items-center gap-2">
        <GitBranch className="w-4 h-4 text-[#005289]" />
        <div className="font-semibold text-sm">Contract Lifecycle Chain</div>
        <span className="text-xs text-slate-500">Master #{data.master_number} · {data.total} document(s)</span>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 overflow-x-auto">
          {data.chain.map((node, i) => (
            <div key={node.id} className="flex items-center gap-2 flex-shrink-0">
              <Link
                to={`/contract/${node.id}`}
                className={`px-3 py-2 rounded-md border text-xs flex flex-col items-start min-w-[130px] ${
                  node.is_current
                    ? "bg-[#005289] text-white border-[#005289]"
                    : "bg-white text-slate-700 border-slate-200 hover:border-[#005289]"
                }`}
                data-testid={`chain-node-${node.contract_number}`}
              >
                <div className="font-bold">#{node.contract_number}</div>
                <div className={`text-[10px] uppercase tracking-wider mt-0.5 ${node.is_current ? "text-white/70" : "text-slate-500"}`}>
                  {node.kind === "master" ? "MASTER" : (node.child_relation || "AMENDMENT").toUpperCase()}
                </div>
                <div className={`text-[10px] ${node.is_current ? "text-white/70" : "text-slate-500"}`}>
                  {node.stage}
                </div>
              </Link>
              {i < data.chain.length - 1 && <span className="text-slate-300">→</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
